import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { ProgressSpinner } from '@openng/optimus-ui/progressspinner';

@Component({
    selector: 'app-loading',
    imports: [ProgressSpinner],
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './loading.component.css',
    template: `
@if (visible()) {
  <div class="loader">
    <p-progressSpinner strokeWidth="4" ariaLabel="Cargando" styleClass="h-12! w-12!" />
  </div>
}
`
})
export class LoadingComponent {
    readonly visible = input<boolean>(false);
}
